"use client";

import { FC } from "react";

export const APP_LANGUAGES = [
  {
    name: "English",
    locale: "en",
  },
];

const LanguageMenu: FC<{ className?: string }> = () => {
  return null;
};

export default LanguageMenu;
